import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconArrowLeftEndOnRectangle = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.5 9V5.25A2.25 2.25 0 0 0 13.25 3h-6A2.25 2.25 0 0 0 5 5.25v13.5A2.25 2.25 0 0 0 7.25 21h6a2.25 2.25 0 0 0 2.25-2.25V15m-3.75 0-3-3 3-3m-3 3H21.5"
    />
  </NcIcon>
);
export { NcIconArrowLeftEndOnRectangle };
